import React, {Component} from 'react';
import cookie from "react-cookies";
import {Button, Result, Row,} from 'antd';
import {updateUrlStateInReducer} from '../redux_actions/search.case.action';
import {connect} from "react-redux";
import '../asset/style/custom_antd_table_style.css';
import {openEndPoint} from "../utils/utils";
import {get_response} from "../helper/request";

class CliaBarrier extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token:"",
      tokenVerified:false,
      processing: true,
    }

    this.props.dispatch(updateUrlStateInReducer(this.props.urlState));
  }

  componentWillMount() {
    this.getToken();
  }

  openCliaPage = () => {
	  openEndPoint("/clia/", false, true)
  }

  openDashboard = () => {
	  openEndPoint("/", false, true);
  }

  verifyToken = (token) =>{
    let url = `/api/token_verifier/?token=${token}`
    get_response(url).then(res => {
      if(res.data["status"] === "CORRECT"){
        this.setState({tokenVerified:true})
        let token = res.data["token"]
        cookie.save('screen_supported', token, { path: '/'});
      }
      else{
        cookie.save('screen_supported', false, { path: '/'});
      }
      this.setState({processing:false})
    })
  }

  getToken = () => {
    let url = window.location.href.split('?')[1];
    let token = '';
    if (url) {
      let partsOfUrl = url.split('&');
      partsOfUrl.forEach((part) => {
          let key = part.split('=')[0];
          let value = part.split('=')[1];
          if (key === 'token') {
              token = value;
              this.setState({token:token})
              this.verifyToken(token)
            }
      });
    }
  }

  render() {
    let verified = cookie.loadAll().screen_supported
    if(this.state.tokenVerified === true){
      this.openCliaPage();
    }
    
    let processing = this.state.processing
    return (
      <Row>
      {processing?
        null
    :
    <div>
    <Result
      title="Your Screen Isnt Supported"
      extra={
        <Button type="primary" key="console" onClick={this.openDashboard}>
          Go To Dashboard
        </Button>
      }
    />
  </div>}
    </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    loginStatus: state.loginAlerts.loginStatus,
    allCases: state.casesReducer,
    allCaseStatus: state.caseStatusReducer.case_status,
    allUsers: state.caseStatusReducer.users,
    numPages: state.caseStatusReducer.numPages,
    pageNumber: state.caseStatusReducer.pageNumber,
    total: state.caseStatusReducer.total,
    urlState: state.searchCaseReducer,
    isFetching: state.searchCaseReducer.isFetching
  };
};

export default connect(mapStateToProps)(CliaBarrier);
